import { defineMessages } from 'react-intl';

export const messages: {
	nextSlide: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	pauseAutoRotation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	playAutoRotation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	previousSlide: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	slide: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	previousSlide: {
		id: 'company-hub.carousel-extension.carousel-navigation.row-orientation.previous-slide',
		defaultMessage: 'Previous slide',
		description:
			'Accessible label for a carousel button that moves back one slide and displays the previous carousel slide.',
	},
	nextSlide: {
		id: 'company-hub.carousel-extension.carousel-navigation.row-orientation.next-slide',
		defaultMessage: 'Next slide',
		description:
			'Accessible label for a carousel button that moves forward one slide and displays the next carousel slide.',
	},
	playAutoRotation: {
		id: 'company-hub.carousel-extension.carousel-navigation.start-auto-rotation',
		defaultMessage: 'Start auto-rotation',
		description:
			'Accessible label for a carousel button that starts automatically rotating through carousel slides.',
	},
	pauseAutoRotation: {
		id: 'company-hub.carousel-extension.carousel-navigation.pause-auto-rotation',
		defaultMessage: 'Pause auto-rotation',
		description:
			'Accessible label for a carousel button that pauses automatic rotation through carousel slides.',
	},
	slide: {
		id: 'company-hub.carousel-extension.carousel-navigation.slide-label',
		defaultMessage: 'Slide {positionInSet} of {setSize}',
		description:
			'Accessible label for a carousel slide selector. {positionInSet} is the slide number and {setSize} is the total number of slides.',
	},
});
